// src/services/gatePassService.ts
import api from "../lib/api.ts";

interface BuyerDepositRequestPaginationParams {
  page?: number;
  limit?: number;
  orderBy?: string;
  order?: "ASC" | "DESC";
}
interface BuyerDepositRequestCreationParams {
  notes: string;
}

export const getPaginatedBuyerDepositRequests = async (
  params: BuyerDepositRequestPaginationParams
) => {
  const response = await api.get("/buyerdepositrequest/paginated", { params });
  return response.data;
};

export const createDepositRequestBuyer = async (
  params: BuyerDepositRequestCreationParams
) => {
  const response = await api.post("/buyerdepositrequests", {
    ...params,
  });
  return response.data;
};
